import ReportingDashboard from './ReportingDashboardWrapper';

export * from './LegacyReportingDashboard';

export default ReportingDashboard;
